import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Treeselect from '@riophae/vue-treeselect';
import Paginate from "vuejs-paginate";
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import {
  BasicSelect
} from 'vue-search-select';
import PageTracker from '../../../common/PageTrackerHelper'
import pendingPods from '../common/pendingPods'
import pendingGroupIdShipments from '../common/pendingGroupIdShipments'
import AllocatedShipmentList from '../common/HanoverShipmentList'
import pendingForAllocationShipments from '../common/pendingForAllocationShipments'
import moment from 'moment'
import keycloak from '../../../common/Keycloak';
import dummyInput from '../common/smartInput.vue';
import { applySmartInputStyles, clearSmartInputStyles, createClearInputWatcher } from "../../../common/inputStyleHelper";

export default {
  name: 'AllocateHandoverShipment',
  components: {
    VueElementLoading,
    Treeselect,
    Paginate,
    BasicSelect,
    'pending-Pods' : pendingPods,
    'pending-group-id-shipment' : pendingGroupIdShipments,
    'Allocated-shipment': AllocatedShipmentList,
    'Pending-for-Allocation-shipment': pendingForAllocationShipments,
    'dummy-input': dummyInput
  },
  mixins:[PageTracker],
  data: function() {
    return {
      ShipmentType: '',
      MarkShipmentStatus: '',
      ddlMisrouteReason: '',
      txtShipment: '',
      reasonObj: [],
      shipmentTypeObj: [],
      shipmentStatusObj: [],
      getHubObj: [],
      hubDiv: true,
      ShipmentType: '',
      hub: '',
      hubid: '',
      CourierCompanyNameObj: [],
      hubname: '',
      DestinationHubNameList: [],
      CourierCompanyName: '',
      CourierCompanyID:'',
      DeliveryUserList: [],
      DestinationHubName: '',
      EmpType: '',
      showAllocatedShipmentflag: false,
      showPendingShipmentflag: false,
      showprintShipmentsforDeliveryflag: false,
      confirmAllocationForPrintflag: false,
      allocatedShipmentList: [],
      pendingAllocationShipmentList: [],
      showprintShipmentsforDeliveryList: [],
      confirmAllocationForPrintList: [],
      isValidationcheck: true,
      txtVehicleNo: '',
      test: 'test',
      dismissSecs: 20,
      dismissCountDown: 0,
      dismissCountDownSuccess: 0,
      allocationSuccessMsg: '',
      allocationErrorMsg: '',
      DestinationObj: {"value":'',"text":''},
      DeliveryUserObj: {"value":'',"text":''},
      srLoader: '',
      HubLoader: '',
      loader:'<div class="velmld-spinner"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="18px" viewBox="0 0 24 30" xml:space="preserve"><rect x="0" y="5.59869" width="4" height="19.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="10" y="9.59869" width="4" height="11.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="20" y="12.4013" width="4" height="6.19739" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect></svg></div>',
      isAllocationLoader: false,
      isConfirmAllocationLoader: false,
      isPendingShipmentLoader : false,
      isAllocatedLoader : false,
      flagShowPreviousShipment: false,
      showShipmentList: [],
      showShipmentModel: false,
      isPodsLoader: false,
      isGroupIdLoader: false,
      showGroupIdShipmentModel: false,
      showParentGroupIdShipmentList: [],
      pendingGrouptErrorMsg: '',
      jobType:'',
      JobTypeObj:{"value":'',"text":''},
      jobTypeList:[
        {
        value: 'Delivery',
        text:"Ecomm - Forward - Delivery"
        },
        {
        value:'RTO',
        text:"Ecomm - Forward - RTO"
        },
        {
        value:'DTO',
        text:"Ecomm - Reverse - Delivery(DTO)"
        }
        // ,
        // {
        // value: 'RVP',
        // text:"Ecomm - Reverse - Pickup(RVP)"
        // }
      ],
      pendingAllocationcnt: 0,
      shipmentKeySearchById: '',
      shipmentKeySearchByIdAllocated:'',
      ActiveTabIndex: 0,
      totalAllocatedShipmentcnt: 0,
      errEbnVehicleNo: '',
      shipmentNo: '',
      errShipmentNo: '',
      fromList: [{ value: "UA",text: "From Mobile"},{value: "Web", text: "From Web"}],
      fromItemObj: { value: "UA",text: "From Mobile"},
      FromId: 'UA',
      currentHubDetails: {},
      isHandoverShipmentListLoader: false,
      HandoverShipmentList: [],
      errShipmentNo: '',
      isAllocation: true,
      isConfirmLoad: false,
      PendingForAllocationShipmentList: [],
      PendingForAllocationShipmentListcnt: 0,
      isPendingAllocationShipmentListLoader: false,
      errorRvpAllocation: "",
      successRvpAllocation: "",
      errorRvpAllocationErrorArrobj: [],
      ShipmentFutureFailedArrObj: [],
      ShipmentFailedArrObj: [],
      errorRvpAllocationErrorArrobj: [],
      IsRVPPaperless: false,
      selectedPickups: [],
      ButtonLabelChange: 'Allocate',
      isAllocating: false,
      courierCompanyNames: '',
      defaultHubName: '',
      PendingPageCount: 1,
      pendingAllocatePageNo: 1,
      pendingAllocatePageSize: 10,
      AllocatedPageCount: 1,
      AllocatedPageSize: 10,
      AllocatedPageNo: 1,
      closeTripModel: false,
      showPaginate:true,
      pendingForAllocationData:[],
      IsPaperlessFlyerbarcode:false,
      selectedPickupsMore: [],
      morePendingRVPShipmentsModel: false,
      errorRvpAllocation: '',
      successRvpAllocation: '',
      suggestRVPArrayList: [],
      sAllMoreShip: false,
      pendingForMoreAllocationData: [],
      loadMoreSameCustomerShipment: false,
      isRVPFeataureEnableForTesting: false,
      hubSpecificRVPAllowed: [1695,3085,614,277,93,1442,405,191,195,190,91,228,1785,2744,516,615,2046],
      flagShowEbnVehicleNo: false,
      ebnVehicleNo: '',
      vehicleNoRegExp: '',
      userDataKey : '',
      allocationMsgprexo : '',
      rvpPrexoShipmentList:[],
      rvpPrexoShipMsg: 'This is a PREXO shipment, and its associated Delivery shipment is :- ',
      rvpPrexoShipMsgBulk: 'You have allocated some prexo shipments, find below associated Delivery shipments :- ',
      isShowDummyInput: false,
      styleData: {},
      dummyInputTimeout: 20000,
    }
  },
  watch: {
    txtShipment: createClearInputWatcher('txtShipment'),
  },
  created: function() {
    //this.getCourierCompanyName();
  },
  async mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    console.log('userdetail', userdetail);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.localusermobilenumber = userdetail.mobilenumber;
    this.localuseroutsourcingid = userdetail.outsourcingid;
    this.localuseruserfullname = userdetail.userfullname;
    this.hubdetails = userdetail.hubdetails[0];

    let checkhub = this.hubSpecificRVPAllowed.find( value => value == this.hubdetails );
    if(process.env.NODE_ENV == 'production' && checkhub != undefined){
      this.isRVPFeataureEnableForTesting = true;
      this.jobTypeList.push({
      value: 'RVP',
      text:"Ecomm - Reverse - Pickup(RVP)"
      });
    }
    if(process.env.NODE_ENV == 'development'){
      this.isRVPFeataureEnableForTesting = true;
      this.jobTypeList.push({
      value: 'RVP',
      text:"Ecomm - Reverse - Pickup(RVP)"
      });
    }
    //console.log('this.hubdetails',this.hubdetails);
    //console.log('localuseroutsourcingid',this.localuseroutsourcingid);
    this.CourierCompanyID = this.localuseroutsourcingid;
    this.CourierCompanyName = this.localuseruserfullname;
    this.CourierCompanyNameObj = [{
      "id" : this.localuseroutsourcingid,
      "name" : this.localuseruserfullname
    }]
    this.CourierCompanyName = this.CourierCompanyID;
    this.courierCompanyNames = this.CourierCompanyNameObj[0].name;

    const IsRVPPaperlessEncrypt = window.localStorage.getItem('IsRVPPaperless')
    const IsRVPPaperlessbytes = CryptoJS.AES.decrypt(IsRVPPaperlessEncrypt.toString(), this.userDataKey);
    const IsRVPPaperlessbytestext = IsRVPPaperlessbytes.toString(CryptoJS.enc.Utf8);
    const paperLessKey = JSON.parse(IsRVPPaperlessbytestext)
    console.log('paperLessKey',paperLessKey);
    if(paperLessKey != null && paperLessKey.trim() == "1") {
      this.IsRVPPaperless = true;
    } else {
      this.IsRVPPaperless = false;
    }
    console.log('this.IsRVPPaperless',this.IsRVPPaperless);

    this.getDeliveryUserName(this.hubdetails);
    //console.log('CourierCompanyNameObj',this.CourierCompanyNameObj);
  //  this.getCourierCompanyName();
    let hubNameObj = await this.getHubDetailsbyID(this.localuserid,this.hubdetails);
    this.currentHubDetails = hubNameObj;
    this.defaultHubName = hubNameObj.HubName;
    this.loadPendingAllocationShipments();
    const vm = this;
    $("#txtShipment").keydown(function (event) {
      var keycode = (event.keyCode ? event.keyCode : event.which);
      if ($(this).val() == '') {
        let keyupFiredCount = 0;
      }
      if (keycode == 13) {
        vm.allocateShipment('form-1');
        //$("#formSubmit").click();
        return false;
        event.stopPropagation();
      }
    });
    this.loadPendingAllocationShipmentsForSameCustomer();
    this.vehicleNoRegExp = new RegExp('^[A-Z]{2}[ -][0-9]{1,2}(?: [A-Z])?(?: [A-Z]*)? [0-9]{4}$');
  },
  computed: {
    flagAllocation() {
      var isComplete = '';
      if(this.jobType=="Delivery" || this.jobType=="RTO" || this.jobType=="DTO") {
        let checkSpecialChars = /[!@#$%^&*`'[+~/(),.?":{}|<>]/;
        if( checkSpecialChars.test(this.txtShipment)==false){
          isComplete = this.jobType && this.txtShipment
          this.errShipmentNo = '';

        } else {
          this.errShipmentNo = 'Please Enter Valid Shipment No.!'
        }
      } else {
        isComplete = this.jobType;
      }
      return isComplete;
    }
  },
  watch: {
    ActiveTabIndex(ActiveTabIndex){
      this.shipmentKeySearchById = '';
    }
  },
  methods: {
    viewFullScreenModel(){
      this.closeTripModel = true;
      if (this.ActiveTabIndex === 0) {
        this.reloadPendingShipmentList();
      }else {
        this.reloadAllocatedShipmentList();
      }
      if(this.$refs.PendingForAllocationShipments.$refs.paginate.selected > 0){
       this.$refs.PendingForAllocationShipments.$refs.paginate.selected = 0;
      }
    },
    closeCloseTripModel(){
      if (this.ActiveTabIndex === 0) {
        this.reloadPendingShipmentList();
      }else {
        this.reloadAllocatedShipmentList();
      }
      this.closeTripModel = false;
      if(this.$refs.PendingForAllocationShipments.$refs.paginate.selected > 0){
       this.$refs.PendingForAllocationShipments.$refs.paginate.selected = 0;
      }
    },
    searchAllPendingAllocationShipments(){
      if(event.keyCode === 13) {
        this.loadPendingAllocationShipments();
      }
    },
    getSelectedShipments(getSelectedShipments){
      //console.log("selectedShipment",getSelectedShipments);
      this.pendingForAllocationData = getSelectedShipments;
    },
    reloadPendingShipmentList(){
      this.pendingAllocatePageNo = 1;
      this.shipmentKeySearchById ="";
      this.loadPendingAllocationShipments();
    },
    reloadAllocatedShipmentList() {
      this.shipmentKeySearchByIdAllocated = '';
      this.AllocatedPageNo = 1;
      this.loadAllocatedShipments();
      this.pendingForAllocationData = [];
    },
    searchAllAllocatedShipments(){
      //console.log('test clicked',event.keyCode);
      if(this.ActiveTabIndex == 0){
        if(event.keyCode === 13) {
          this.loadPendingAllocationShipments()
        }
      } else {
        if(event.keyCode === 13) {
          this.loadAllocatedShipments()
        }
      }
    },
    getPaginationData(pageNum){
      this.pendingAllocatePageNo = pageNum
      this.loadPendingAllocationShipments();
    },
    loadPendingAllocationShipments(){
      this.isPendingAllocationShipmentListLoader = true;
      let srId = this.ddlMisrouteReason.split("@");
      let reqPayload = {
          "ShipmentType": this.jobType,
          "HubId": this.hubdetails,
          "OutSourcingMasterId": this.localuseroutsourcingid,
          "isHandover": "1",
          "pageNo": this.pendingAllocatePageNo,
          "pageSize": this.pendingAllocatePageSize
      }
      if(this.shipmentKeySearchById !="") {
        reqPayload["ShippingId"] = this.shipmentKeySearchById.trim()
        reqPayload["pageNo"] = 0;
      }

      axios({
        method: 'POST',
        url: apiUrl.api_url + 'pending/shipments/byHubID',
        data: reqPayload
      })
      .then(result => {
        if (result.data.code==200) {
          this.PendingForAllocationShipmentList = result.data.data
          this.PendingForAllocationShipmentListcnt = result.data.totalcount;
          if (this.PendingForAllocationShipmentListcnt < this.pendingAllocatePageSize) {
            this.PendingPageCount = 1
          } else {
            this.PendingPageCount = Math.ceil(this.PendingForAllocationShipmentListcnt / this.pendingAllocatePageSize);
          }
        } else {
          this.PendingPageCount = 0;
          this.PendingForAllocationShipmentListcnt = 0;
          this.PendingForAllocationShipmentList = [];
        }
        this.isPendingAllocationShipmentListLoader = false
      }, error => {
        this.isPendingAllocationShipmentListLoader = false
        console.error(error)
      })
    },
    getAllocatedPaginationData(pageNum){
      this.AllocatedPageNo = pageNum
      this.loadAllocatedShipments();
    },
    loadAllocatedShipments() {
      let srId = this.ddlMisrouteReason.split("@");
      let reqPayload = {
          "ShipmentType": this.jobType,
          "HubId": this.hubdetails,
          "OutSourcingMasterId": this.localuseroutsourcingid,
          "DeliveryUserId": srId[0],
          "pageNo": this.AllocatedPageNo,
          "pageSize": this.AllocatedPageSize
      }
      if (this.shipmentKeySearchByIdAllocated) {
        reqPayload.ShippingId = this.shipmentKeySearchByIdAllocated
      }
      this.isHandoverShipmentListLoader = true;
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'allocated/shipments/byAgent',
        data: reqPayload
      })
      .then(result => {
        if (result.data.code==200) {
          this.HandoverShipmentList = result.data.data
          this.totalAllocatedShipmentcnt = result.data.totalcount;
          if (this.totalAllocatedShipmentcnt < this.AllocatedPageSize) {
            this.AllocatedPageCount = 1
          } else {
            this.AllocatedPageCount = Math.ceil(this.totalAllocatedShipmentcnt / this.AllocatedPageSize);
          }
        } else {
          this.AllocatedPageCount = 1;
          this.totalAllocatedShipmentcnt = 0;
          this.HandoverShipmentList = [];
        }

        this.isHandoverShipmentListLoader = false
      }, error => {
        this.isHandoverShipmentListLoader = false
        console.error(error)
      })

    },
    selectFrom(obj){
      this.fromItemObj = obj;
      this.FromId = this.fromItemObj.value;
    },
    onlyNumber($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 8 && keyCode !== 44) {
        $event.preventDefault();
      }
    },

    clear() {
      this.isShowDummyInput = false;
      this.$refs.dummyShipInputBox.clearStyles();
    //  this.CourierCompanyName = '',
    //  this.CourierCompanyID ='',
      this.DestinationHubName = '',
      this.showAllocatedShipmentflag = false;
      this.showPendingShipmentflag = false;
      this.showprintShipmentsforDeliveryflag = false;
      this.confirmAllocationForPrintflag = false;
      this.isValidationcheck = true;
      this.ShipmentType = '',
      this.MarkShipmentStatus = '',
      this.ddlMisrouteReason = '',
      this.txtShipment = '',
      this.txtVehicleNo ='',
      this.reasonObj = [],
      this.DestinationObj = {}
      this.DeliveryUserObj = {}
      this.hubDiv = true,focus
      this.$validator.reset();
      this.errors.clear();
      this.allocatedShipmentList = []
      this.pendingAllocationShipmentList = []
      this.showprintShipmentsforDeliveryList = []
      this.confirmAllocationForPrintList = []
      this.isAllocationLoader = false
      this.isConfirmAllocationLoader = false
      this.test = 'test',
      this.JobTypeObj = {},
      this.jobType = '';
    },
    getCourierCompanyName() {

      this.CourierCompanyName = this.localuseruserfullname;
      this.CourierCompanyID = this.localuseroutsourcingid;
      axios.post(apiUrl.api_url + 'agenthandovershipments/couriercompanyname', {
          'EntityType': 'Agent'
        })
        .then((response) => {
          if (response.data.code === 200) {
            this.CourierCompanyNameObj = response.data.data;
          } else {
            this.CourierCompanyNameObj = [];
          }
        })
        .catch((httpException) => {
          this.$alertify.success("Courier Company data not found");
          console.error('exception is:::::::::', httpException)
        })

    },
    loadPendingAllocationShipmentsForSameCustomer(){

      let reqPayload = {
          "ShipmentType": 'RVP',
          "HubId": this.hubdetails,
          "OutSourcingMasterId": this.localuseroutsourcingid,
          "isHandover": "1",
          "pageNo": 0,
          "pageSize": 0
      }

      axios({
        method: 'POST',
        url: apiUrl.api_url + 'pending/shipments/byHubID',
        data: reqPayload
      })
      .then(result => {
        if (result.data.code==200) {
          this.PendingAllAllocationList = result.data.data
        } else {
          this.PendingAllAllocationList = [];
        }
      }, error => {
        this.isPendingAllocationShipmentListLoader = false
        console.error(error)
      })
    },
    //to get Destination Hub Name
    getDestinationHubName() {

      this.HubLoader = this.loader;
      if (this.CourierCompanyName == 0) {
        return false;
      }
      axios.post(apiUrl.api_url + 'agenthandovershipments/gethublist?OutSourcingMasterID=' + this.CourierCompanyName, {})
        .then((response) => {
          if (response.data.code === 200) {
            this.hubname = '';
            $.each(response.data.data , (key,obj)=>{
              this.DestinationHubNameList.push({
                value: obj.HubID,
                text: obj.HubNameWithId
              })
            })
            //this.DestinationHubNameList = response.data.data;
          } else {
            this.DestinationHubNameList = [];
            this.$alertify.error("Destination Hub Data Not found");
          }
          this.HubLoader = '';
        })
        .catch((httpException) => {
          this.HubLoader = '';
          this.$alertify.success("Destination Hub data not found");
          console.error('exception is:::::::::', httpException)
        })
    },
    selectDestinationHubName(obj){
      this.DestinationHubName = obj.value;
      this.DestinationObj = obj;
      this.DeliveryUserObj = {};
      this.ddlMisrouteReason = '';
      this.getDeliveryUserName(this.DestinationHubName);
    },
    getDeliveryUserName(hubid) {
      this.srLoader = this.loader;
      this.DeliveryUserList = [];
      if (hubid == 0) {
        return false;
      }

      let Emppayload = {
        "OutSourcingId": this.CourierCompanyName,
        "hubid": [hubid]
      }
      let apiendpoint = 'agenthandovershipments/getDeliveryUserName';
      if (keycloak.enableKavach) {
        apiendpoint = 'user/migration/getoutsourceuserlist';
      }
      axios.post(apiUrl.api_url + apiendpoint, {
          Emppayload
        })
        .then((response) => {

          if (response.data.code === 200) {
            $.each(response.data.data , (key,obj)=>{
              this.DeliveryUserList.push({
                value: `${obj.DeliveryUserId}@${obj.EmpType}@${obj.FirstName}@${obj.LastName}@${obj.MobileNumber}`,
                text: `${obj.FirstName} ${obj.LastName} (${obj.OldDeliveryUserOrUserId} - ${obj.DeliveryUserId}) - (${obj.MobileNumber})`
              })
            })
            //this.DeliveryUserList = response.data.data;
          } else {
            this.DeliveryUserList = [];
            this.$alertify.error("Delivery User Data Not Found");
          }
          this.srLoader = '';
        })
        .catch((httpException) => {
          this.srLoader = '';
          //this.$alertify.error("Delivery User Data Not Found");
          console.error('exception is:::::::::', httpException)
        })
    }, //end of getDeliveryUserName function
    selectDeliveryUser(obj) {
      // this.ddlMisrouteReason = obj.value;
      let srId = obj.value.split('@')[0];
      let hubid = this.hubdetails.toString();
      this.validateEODAllocation(srId, hubid,obj);
      this.DeliveryUserObj = obj;
    },

    selectJobType(obj){

    if (obj.value === 'RVP') {
      this.FromId = 'UA';
    }else {
      this.FromId = this.fromItemObj.value;
    }
      this.jobType = obj.value;
      this.JobTypeObj = obj;
     if(this.jobType == 'RVP'){
       this.ButtonLabelChange = 'Allocate Pickup';
     } else {
       this.ButtonLabelChange = 'Allocate';
     }
     this.txtShipment = '';
     if(this.$refs.PendingForAllocationShipments.$refs.paginate.selected > 0){
      this.$refs.PendingForAllocationShipments.$refs.paginate.selected = 0;
     }

     this.reloadPendingShipmentList();
     this.reloadAllocatedShipmentList();
   },
   closeRvpSuggestShipmentsModel(){
     this.morePendingRVPShipmentsModel = false
   },
   selectAllMoreRVPShipments(ev){
     this.pendingForMoreAllocationData = [];
     if (ev.target.checked == true) {
       $.each(this.suggestRVPArrayList, (key,value) => {
         this.pendingForMoreAllocationData.push(value.shippingid);
       })
     }else {
       this.pendingForMoreAllocationData = [];
     }
   },
   checkSameCustPendingForRVP() {
     this.selectedPickupsMore=[]
     this.isAllocating = true;
     this.getPendingForRVPList().then( (result) => {
       if(result.success) {
         this.morePendingRVPShipmentsModel = true
         this.isActiveRvp=true
         this.isAllocating = false
       } else {
         let selectedShipments = this.pendingForAllocationData;
         //console.log('not matched shipment go direct for allocation.');
         this.allocatePickup(selectedShipments);
       }
     });
   },
   MergeSameCustomerSelectionShipment(){
     let mergeRvpShipmentData = [];
     $.each(this.pendingForAllocationData, (key,value) => {
       mergeRvpShipmentData.push(value);
     })

     if(this.pendingForMoreAllocationData.length > 0){
       $.each(this.pendingForMoreAllocationData, (key, value) => {
         mergeRvpShipmentData.push(value);
       })
     }
     //console.log('mergeRvpShipmentData',mergeRvpShipmentData);
     this.morePendingRVPShipmentsModel = false;
     this.allocatePickup(mergeRvpShipmentData);

   },
   getPendingForRVPList() {
     this.errorRvpAllocation = "";
     this.successRvpAllocation = '';
     //console.log('this.pendingForAllocationData',this.PendingForAllocationShipmentList);
     return new Promise( (resolve, reject) => {
       this.suggestRVPArrayList = []
       var relShippingIds = []
       axios({
         method: 'POST',
         url: apiUrl.api_url + 'expose/get/rvp/shipments',
         data: {ShippingID:this.pendingForAllocationData,CourierCompanyId: this.CourierCompanyName.toString()}
       })
       .then(response => {
         var resultData = response.data
         if(resultData.code == 200 && typeof resultData.data !== 'undefined') {
           var result = resultData.data
           for (var i = 0; i < result.length; i++) {
             if(result[i].ReversePickUpData.length>0) {
               let tempData = result[i].ReversePickUpData
               for (var j = 0; j < tempData.length; j++) {
                 relShippingIds.push(tempData[j])
               }
             }
           }
           if(relShippingIds.length>0) {
             for (var i = 0; i < relShippingIds.length; i++) {
               for (var j = 0; j < this.pendingForAllocationData.length; j++) {
                 if(relShippingIds[i]==this.pendingForAllocationData[j]) {
                   relShippingIds.splice(i,1);
                 }
               }
             }
             var uniqueArray = []
             for (var i = 0; i < relShippingIds.length; i++) {
               if(uniqueArray.indexOf(relShippingIds[i]) === -1) {
                 uniqueArray.push(relShippingIds[i]);
               }
             }
             // console.log(uniqueArray.length);
             // console.log(this.pickupList.length);
             var suggestRVPArrayList=[]
             for (var i = 0; i < this.PendingAllAllocationList.length; i++) {
               if(uniqueArray.includes(this.PendingAllAllocationList[i].shippingid)) {
                 this.suggestRVPArrayList.push(this.PendingAllAllocationList[i]);
               }
             }
             resolve({success:true});
           }
         } else {
           resolve({success:false});
         }
       }, error => {
         resolve({success:false});
       })
     });
   },
   allocation(){
     if(this.jobType == 'RVP') {
       let getSelectedData = this.pendingForAllocationData;
       if(getSelectedData.length > 0){
         this.checkSameCustPendingForRVP()
       } else {
         this.$alertify.error('Please select atleast one shipment from Pending for allocation list.!');
       }
     } else {
       this.allocateShipment();
     }
   },
    allocateShipment(scope) {
       this.isShowDummyInput = false;
      // this.$validator.validateAll(scope).then(result => {
      //   if (result) {
          if(this.flagShowEbnVehicleNo == true){
            if(this.vehicleNoRegExp.test(this.ebnVehicleNo.toUpperCase())==false) {
              return this.errEbnVehicleNo = 'Enter Correct Vehicle No';
            }
          }
          this.errEbnVehicleNo = "";
          this.flagShowPreviousShipment = false;
          this.isAllocating = true;
          this.allocationSuccessMsg = '';
          this.allocationErrorMsg = '';
          let [DeliveryUserId, EmpType, DeliveryUserFirstName, DeliveryUserLastName,srMobileNo] = this.ddlMisrouteReason.split('@');
          let OldDeliveryUser = this.DeliveryUserObj.text.split('(');
          let OldDeliveryUserOrUserId = OldDeliveryUser[1].split('-')[0].trim();

          var allocateShipmentPayload = {
            XBkey: "XB123",
            HubId: this.hubdetails.toString(),
            DeliveryUserId: DeliveryUserId,
            ShippingID: this.txtShipment.trim(),
            LastModifiedBy: this.localusermailid,
            IsConfirmAllocation: false,
            AllocationType: this.jobType,
            EmpType: EmpType,
            MarkedFrom: "web",
            CourierCompanyID: this.CourierCompanyName,
            IsRSVCSr: 0,
            MobileNo: srMobileNo ? srMobileNo.toString():"",
            DeliveryUserName: DeliveryUserFirstName + DeliveryUserLastName,
            OldDeliveryUserOrUserId : OldDeliveryUserOrUserId,
            vehicleno: this.ebnVehicleNo
          }
          //calculating related PREXO shipments type based upon input shipmentType
          let prexoShipmentType = (this.jobType.toLowerCase() == 'delivery' && !['rto','dto','rto/dto'].includes(this.jobType.toLowerCase())) ? 'RVP' : 'Delivery';


          axios.post(apiUrl.api_url + 'agenthandovershipments/allocateShipment', allocateShipmentPayload)
            .then((response) => {
              this.isShowDummyInput = true;
              this.styleData = response.data.lossCategorization;

              let tempStr = this.txtShipment;

              if (response.data.code == 200) {
                let TrackerInfo = {
                  projectname:"Last Mile",
                  type:"Web",
                  userid:this.localuserid,
                  username:this.localusermailid,
                  meta: {
                      "event":"allocateShipment",
                      "ShippingID": this.txtShipment.trim().toString(),
                      "companyName" : this.CourierCompanyName,
                      "AllocationType": this.jobType,
                      "DeliveryUserId": DeliveryUserId
                  }
                }
                this.PageTracker(TrackerInfo);
                //this.$alertify.success("Sucess");
                this.dismissCountDownSuccess = this.dismissSecs;
                this.allocationSuccessMsg = tempStr+" :- "+response.data.message;
                this.allocationMsgprexo  = response.data.prexoShipment ? ('This is a PREXO shipment, and its associated '+ prexoShipmentType +' shipment is :-'+ response.data.prexoShipment): null;
                this.$alertify.success(response.data.message);
                this.flagShowEbnVehicleNo = false;
                this.txtShipment = '';
                this.ebnVehicleNo = '';
              } else if (response.data.code == 202) {
                this.ebnVehicleNo = '';
                this.flagShowEbnVehicleNo = false;
                if(typeof response.data.data.status !=undefined && response.data.data.status==204) {
                  this.flagShowPreviousShipment = true
                }

                if(typeof response.data.data.status !=undefined && response.data.data.status==207) {
                  this.flagShowEbnVehicleNo = true;
                  this.txtShipment = tempStr;
                  this.$refs.ebnVehicleNo.focus();
                }

                if(typeof response.data.message.details !== 'undefined') {
                  this.dismissCountDown = this.dismissSecs;
                  this.allocationErrorMsg = response.data.message.details[0].message;
                  //Handle Prexo shipment error
                  this.allocationMsgprexo  = response.data.prexoShipment ? ('This is a PREXO shipment, and its associated ' + prexoShipmentType + ' shipment is :-'+ response.data.prexoShipment) : null;
                } else {
                  this.dismissCountDown = this.dismissSecs;
                  this.allocationErrorMsg = tempStr+" :- "+response.data.message;
                  //Handle Prexo shipment error
                  this.allocationMsgprexo  = response.data.prexoShipment ? ('This is a PREXO shipment, and its associated ' + prexoShipmentType + ' shipment is :-'+ response.data.prexoShipment) : null;
                }
                //this.$alertify.error(response.data.message);
              } else if (response.data.code == 500) {
                //this.$alertify.success("Error");
                this.dismissCountDown = this.dismissSecs;
                this.allocationErrorMsg = tempStr+" :- "+response.data.message;
                //Handle Prexo shipment error
                this.allocationMsgprexo  = response.data.prexoShipment ? ('This is a PREXO shipment, and its associated ' + prexoShipmentType + ' shipment is :-'+ response.data.prexoShipment) : null;
                this.flagShowEbnVehicleNo = false;
                //this.$alertify.error(response.data.message);
              } else {
                this.dismissCountDown = this.dismissSecs;
                this.allocationErrorMsg = tempStr+" :- "+response.data.message;
                //Handle Prexo shipment error
                this.allocationMsgprexo  = response.data.prexoShipment ? ('This is a PREXO shipment, and its associated ' + prexoShipmentType + ' shipment is :-'+ response.data.prexoShipment) : null;
              }
              // this.txtShipment = '';
              this.pendingForMoreAllocationData = [];
              this.suggestRVPArrayList = [];
              this.sAllMoreShip = false;
              this.$refs.txtShipment.focus();
              this.$validator.reset();
              this.errors.clear();
              this.isAllocating = false
            })
        //}
      // }).catch(() => {
      //   console.log('errors exist', this.errors)
      //   this.isAllocationLoader = false
      // });
    }, //end of allocateShipment function
    allocatePickup(getShipmentlistToAllocate) {
      this.selectedPickups = getShipmentlistToAllocate;
      //console.log('selectedPickups',this.selectedPickups);
      var self = this;
      this.errorRvpAllocation = "";
      this.successRvpAllocation = '';
      this.errorRvpAllocationErrorArrobj = [];
      this.ShipmentFutureFailedArrObj = [];
      this.ShipmentFailedArrObj = [];
      if(this.selectedPickups.length>0) {
        this.isAllocating = true
        this.resArray = [];
        var successCount = 0;
        var failCount = 0;
        var failCountFutureDate = 0;
        var failShipmentsFDArray = [];
        var failShipmentsArray = [];

        let chain = Promise.resolve();
        for(let val of this.selectedPickups) {
          chain = chain.then(() => self.bulkAllocation(val));
        }
        chain.then(() => {
          var result = this.resArray
          console.log('result',result);
          for (var i = 0; i < result.length; i++) {
            if (result[i].statusCode==206) {
              failShipmentsFDArray.push(result[i].shippingId)
              failCountFutureDate++;
                this.ShipmentFutureFailedArrObj.push(result[i]);
            } else if (result[i].statusCode==200) {
              successCount++;
              if(result[i].prexoShipment){
                this.rvpPrexoShipmentList.push(parseInt(result[i].prexoShipment));
              }
            } else {
              failCount++;
              this.ShipmentFailedArrObj.push(result[i]);
            }
          }
          if(failCount>0) {
            self.errorRvpAllocation = failCount+" shipping ids cannot assign for pickup."
            this.errorRvpAllocationErrorArrobj = this.ShipmentFailedArrObj;
          }
          if(failCountFutureDate>0) {
            self.errorRvpAllocation = failCountFutureDate+" these shipping ids cannot assign for pickup, because pickup date set as a future date.";
            this.errorRvpAllocationErrorArrobj = this.ShipmentFutureFailedArrObj;
          }
          if(successCount>0) {

            self.successRvpAllocation = successCount+" shipments allocated successfully";
          }
          this.isAllocating = false;
          this.pendingForAllocationData = [];
          this.pendingForMoreAllocationData = [];
          this.suggestRVPArrayList = [];
          this.sAllMoreShip = false;
          this.loadPendingAllocationShipments();
          //this.PendingForAllocationShipmentList = this.selectedPickups;
        }).catch(err=>{
          self.errorRvpAllocation = err.message;
          this.isAllocating = false;
        });
      }
    },
    bulkAllocation(shippingId) {
      if(shippingId !=undefined && shippingId !="") {
        //var clientId = $("#CI"+shippingId).val();
        //console.log('test',shippingId);
        return new Promise( (resolve, reject) => {
          this.files = []
          // var selectedSrDtl = this.srArrayList.filter(n=>{
          //   return n.userid==this.srId
          // })
          let [DeliveryUserId, EmpType, DeliveryUserFirstName, DeliveryUserLastName,srMobileNo] = this.ddlMisrouteReason.split('@');
          let RVPOldDeliveryUser = this.DeliveryUserObj.text.split('(');
          let RVPOldDeliveryUserOrUserId = RVPOldDeliveryUser[1].split('-')[0].trim();

          let input = {
            "XBkey":"XB123",
          	"HubId":this.hubdetails.toString(),
          	"DeliveryUserId":DeliveryUserId,
            "OldDeliveryUserOrUserId": RVPOldDeliveryUserOrUserId ? RVPOldDeliveryUserOrUserId.toString() :"0",
          	"DeliveryUserName":`${DeliveryUserFirstName} ${DeliveryUserLastName}`,
          	"ShippingID":shippingId,
          	"LastModifiedBy":this.localusermailid,
          	"IsConfirmAllocation":false,
          	"AllocationType":this.jobType,
            "EmpType":EmpType ? EmpType:"",
          	"MarkedFrom":"Web",//this.fromId,
          	"CourierCompanyID":this.CourierCompanyName?this.CourierCompanyName.toString():'null',
            "IsRSVCSr": 0,
          	"MobileNo":srMobileNo?srMobileNo.toString():"",
            "IsRVPPaperless": this.IsRVPPaperless
          }

          axios({
            method: 'POST',
            url: apiUrl.api_url + 'expose/shipment/allocate',
            data: input
          })
          .then(result => {
            var result = result.data;
            //Handle Prexo shipment error and succes msg
            let finalObjOfErrorOrSuccess = {"success":false, "statusCode":result.status, "message":result.message, "shippingId":shippingId}
            if(result.prexoShipment){
              finalObjOfErrorOrSuccess['prexoShipment']=result.prexoShipment
            }
            
            if(result.status==204) {
              //Handle Prexo shipment error
              this.resArray.push(finalObjOfErrorOrSuccess);
              // this.resArray.push({"success":false, "statusCode":result.status, "message":result.message, "shippingId":shippingId});
              resolve({"success":false, "statusCode":result.status, "message":result.message, "shippingId":shippingId});
              //reject({"success":false, "statusCode":result.status, "message":result.message, "shippingId":shippingId});
            } else if (result.status==206) {
              this.resArray.push(finalObjOfErrorOrSuccess)
              // this.resArray.push({"success":false, "statusCode":result.status, "message":result.message, "shippingId":shippingId})
              resolve();
            } else if (result.code==200) {
              //$("#rvpTr"+shippingId).remove();
              let TrackerInfo = {
                projectname:"Last Mile",
                type:"Web",
                userid:this.localuserid,
                username:this.localusermailid,
                meta: {
                    "event":"bulkAllocation",
                    "ShippingID": shippingId.toString(),
                    "companyName" : this.CourierCompanyName?this.CourierCompanyName.toString():'null',
                    "AllocationType":this.jobType,
                    "DeliveryUserId":DeliveryUserId
                }
                }
              this.PageTracker(TrackerInfo);
              for (var i = 0; i < this.selectedPickups.length; i++) {
                if(this.selectedPickups[i]==shippingId) {
                  this.selectedPickups.splice(i, 1);
                }
              }
              finalObjOfErrorOrSuccess.success = true;
              finalObjOfErrorOrSuccess.statusCode = result.code;
              this.resArray.push(finalObjOfErrorOrSuccess)
              // this.resArray.push({"success":true, "statusCode":result.code, "message":result.message, "shippingId":shippingId})
              resolve();
            } else {
              finalObjOfErrorOrSuccess.statusCode = result.code;
              this.resArray.push(finalObjOfErrorOrSuccess)
              // this.resArray.push({"success":false, "statusCode":result.code, "message":result.message, "shippingId":shippingId})
              resolve();
            }
          }, error => {
            console.error(error)
            reject({"success":false, "statusCode":null, "message":"server error, Try later"});
          })
        })
      } else {
        reject({"success":false, "statusCode":null, "message":"ClientId not found"});
      }
    },
    clearSR(){
      this.isShowDummyInput = false;
      this.$refs.dummyShipInputBox.clearStyles();
      this.$refs.dummyShipInputBox2.clearStyles();
      this.ddlMisrouteReason = '';
      this.DeliveryUserObj = {},
      this.jobType = '',
      this.JobTypeObj = {"value":'',"text":''},
      this.txtShipment = '',
      this.txtVehicleNo = ''
      this.$validator.reset();
      this.errors.clear();
    },
    // Sonal API Call
    showAllocatedShipment(scope) {
      if (!this.CourierCompanyName) {
        this.$alertify.error("Please Select Courier Company Name");
      } else if (!this.DestinationHubName) {
        this.$alertify.error("Please select Destination Hub Name");
      } else if (!this.ddlMisrouteReason) {
        this.$alertify.error("Please Select Delivery User");
      } else {
        this.isAllocatedLoader = true;
        this.showAllocatedShipmentflag = true;
        this.showPendingShipmentflag = false;
        this.showprintShipmentsforDeliveryflag = false;
        let [DeliveryUserId, EmpType] = this.ddlMisrouteReason.split('@');
        let ShipmentAllocatedpayload = {
          UserHubID: this.DestinationHubName.toString(),
          CourierID: this.CourierCompanyName.toString(),
          DeliveryUserId: DeliveryUserId,
          Status: "10",
          ClientVendorId: "test"
        }
        axios.post(apiUrl.api_url + 'agenthandovershipments/showAllocatedShipment', {
            ShipmentAllocatedpayload
          })
          .then((response) => {
            //console.log('Response : ', response);
            if (response.data.code === 200) {
              this.allocatedShipmentList = response.data.data;
              this.allocatedShipmentList.sort(function(a, b) {
                return a.ShippingId - b.ShippingId;
              });
              //console.log('allocatedShipmentList :', this.allocatedShipmentList);
            } else {
              this.allocatedShipmentList = [];
              this.$alertify.error("Allocated Shipment Data Not Found");
            }
            this.isAllocatedLoader = false;
          })
          .catch((httpException) => {
            this.isAllocatedLoader = false;
            this.$alertify.error("Allocated Shipment Data Not Found");
            console.error('exception is:::::::::', httpException)
          })
      }
    }, //end of showAllocatedShipment() function

    // Urmila API Call
    showPendingAllocationShipment() {
      let PendingAllocationShipmentpayload;
      if (!this.CourierCompanyName) {
        this.$alertify.error("Please Select Courier Company Name");
      } else {
        this.isPendingShipmentLoader = true;
        this.showPendingShipmentflag = true;
        this.showAllocatedShipmentflag = false;
        this.showprintShipmentsforDeliveryflag = false;
        if (!this.DestinationHubName) {
          PendingAllocationShipmentpayload = {
            CourierID: this.CourierCompanyName
          }
        } else {
          PendingAllocationShipmentpayload = {
            HubID: this.DestinationHubName,
            CourierID: this.CourierCompanyName
          }
        }
        //        console.log("PendingAllocationShipmentpayload", PendingAllocationShipmentpayload);
        axios.post(apiUrl.api_url + 'agenthandovershipments/showPendingAllocationShipment', {
            PendingAllocationShipmentpayload
          })
          .then((response) => {
            //console.log('Response : ', response);
            if (response.data.code === 200) {
              this.pendingAllocationShipmentList = response.data.data;
              this.pendingAllocationShipmentList.sort(function(a, b) {
                return a.ShippingId - b.ShippingId;
              });
            } else if (response.data.code === 500) {
              this.pendingAllocationShipmentList = [];
              this.$alertify.error(response.data.message);
            } else {
              this.pendingAllocationShipmentList = [];
              this.$alertify.error("Pending Shipment Allocation Data Not Found");
            }
            this.isPendingShipmentLoader = false;
          })
          .catch((httpException) => {
            this.isPendingShipmentLoader = false;
            this.$alertify.error("Pending Shipment Allocation Data Not Found");
            console.error('exception is:::::::::', httpException)
          })
      }
    }, //end showPendingAllocationShipment() Function

    //Call Mahesh API
    confirmAllocationForPrint() {
      this.showParentGroupIdShipmentList = [];
      this.isConfirmLoad = true;
      //***** Below Logic for Pawan API Request PayLoad *********************************
      //console.log('allocatedShipmentList :', this.allocatedShipmentList);
      let allocatedShipmentListPayload = []
      this.allocatedShipmentList.map(result => {
        if (result.netpayment >= 5000 || result.GSTAmount >= 5000 ||
          result.TotalInvoiceValue >= 5000 || result.DeclaredValue >= 5000) {
          allocatedShipmentListPayload.push({
            shippingid: result.ShippingId,
            fromState: result.PickupCity,
            fromPlace: result.PickupState
          });
        }
      });
      //console.log('allocatedShipmentListPayload:',allocatedShipmentListPayload);
      //***** End Logic for Pawan API Request PayLoad *********************************

      let [DeliveryUserId, EmpType] = this.ddlMisrouteReason.split('@');
      let ConfirmAllocationForPrintpayload = {
        XBkey: "XB123",
        sruserid: DeliveryUserId,
        hubid: this.hubdetails,
        isHandoverDeliveryUser: 1,
        LastModifiedBy: this.localusermailid,
        MarkedFrom: this.FromId,
        CourierCompanyID: this.CourierCompanyID,
        shipmentdetails: allocatedShipmentListPayload,
        // vehicleUpdateReason:"first time",
        // transportMode:"road",
        //vehicleNo:"MH34345678",
        vehicleNo: this.txtVehicleNo
      }
      //console.log("ConfirmAllocationForPrintpayload:",ConfirmAllocationForPrintpayload);
      axios.post(apiUrl.api_url + 'agenthandovershipments/confirmAllocationForPrint', ConfirmAllocationForPrintpayload)
        .then((response) => {
          //console.log("response", response.data);
          if (response.data.code == 200) {
            //this.$alertify.success("Sucess");
            this.$alertify.success(response.data.message);
            this.confirmAllocationForPrintList = [];
            this.clear();
            if(this.ActiveTabIndex == 0){
              this.reloadPendingShipmentList();
            } else {
              this.reloadAllocatedShipmentList();
            }

          } else {
            //this.$alertify.success("Error");
            if(response.data.status == 208) {
              this.showGroupIdShipmentModel = true;
              this.pendingGrouptErrorMsg = response.data.message;
              this.showParentGroupIdShipmentList = response.data.data;
            } else {
              this.$alertify.error(response.data.message!='' && response.data.message!=undefined?response.data.message:'Not getting any response message.')
              this.confirmAllocationForPrintflag = true;
              this.confirmAllocationForPrintList = response.data.data;
            }
            //this.$alertify.error(response.data.message);
            //console.log('this.confirmAllocationForPrintList',this.confirmAllocationForPrintList);
            // this.confirmAllocationForPrintList.sort(function(a, b) {
            //   return a.ShippingID - b.ShippingID;
            // });
          }
          this.isConfirmLoad = false;
        })
        .catch((httpException) => {
          this.$alertify.error("Unable to Confirm Allocation Record");
          console.error('exception is:::::::::', httpException)
          this.isConfirmLoad = false;
        });
    }, //end confirmAllocationForPrint() Function

    // Call Mahesh API
    showPrintShipmentsforDelivery() {
      this.showprintShipmentsforDeliveryflag = true;
      this.showAllocatedShipmentflag = false;
      this.showPendingShipmentflag = false;
      let [DeliveryUserId, EmpType] = this.ddlMisrouteReason.split('@');
      let ShowPrintShipmentsforDeliveryPayload = {
        XBkey: "XB123",
        lastSyncDateTime: "",
        DeliveryUserId: DeliveryUserId,
        HubId: this.DestinationHubName.toString(),
        AppType: "web"
      }
      axios.post(apiUrl.api_url + 'agenthandovershipments/showPrintShipmentsforDelivery', {
          ShowPrintShipmentsforDeliveryPayload
        })
        .then((response) => {
          //console.log('Response : ', response);
          if (response.data.code === 200) {
            this.showprintShipmentsforDeliveryList = response.data.data;
            this.showprintShipmentsforDeliveryList.sort(function(a, b) {
              return a.ShippingID - b.ShippingID;
            });
          } else {
            this.showprintShipmentsforDeliveryList = [];
            this.$alertify.error("Allocated Shipment Data Not Found");
          }
        })
        .catch((httpException) => {
          this.$alertify.error("Allocated Shipment Data Not Found");
          console.error('exception is:::::::::', httpException)
        })
    }, //end of showAllocatedShipment() function

    async confirmAllocation() {
      if(!this.ddlMisrouteReason) {
        this.$alertify.error("Please Select Delivery User");
      } else if (!this.txtVehicleNo) {
        this.$alertify.error("Enter Vehicle No.");
      } else if (!/^[A-Z]{2}[ -][0-9]{1,2}(?: [A-Z])?(?: [A-Z]*)? [0-9]{4}$/.test(this.txtVehicleNo) ||
        this.txtVehicleNo.length <= 6 || this.txtVehicleNo.length >= 16) {
        this.$alertify.error("Invalid Vehicle No.");
      } else {
        let message = {
          title: 'Information!!!',
          body: 'Do you really Confirm Shipment Allocation?',
        };
        let res = await this.$dialog.confirm(message, {
          animation: 'bounce',
          backdropClose: true
        })
        if (res) {
          //console.log('yes', res);
          this.confirmAllocationForPrint();
        }
      }
    },
    async confirmPrintShipments() {
      if (!this.CourierCompanyName) {
        this.$alertify.error("Please Select Courier Company Name");
      } else if (!this.DestinationHubName) {
        this.$alertify.error("Please select Destination Hub Name");
      } else if (!this.ddlMisrouteReason) {
        this.$alertify.error("Please Select Delivery User");
      } else {
        let message = {
          title: 'Information!!!',
          body: 'Do you really Print Shipments for Delivery?',
        };
        let res = await this.$dialog.confirm(message, {
          animation: 'bounce',
          backdropClose: true
        })
        if (res) {
          //console.log('yes', res);
          this.showPrintShipmentsforDelivery();
        }
      }
    },
    countDownChangedSuccess(dismissCountDownSuccess) {
      this.dismissCountDownSuccess = dismissCountDownSuccess
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    ShowShipments() {
      this.showShipmentModel = true
      this.isPodsLoader = true;
      let srId = this.ddlMisrouteReason.split("@");
      this.showShipmentList = []
      let inputP = {
        "DeliveryUserId": srId[0]
      }
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'expose/shipment/previous',
        data: inputP
      })
      .then(result => {
        if (result.data.code==200) {
          this.showShipmentList = result.data.data;
        } else {
          this.$alertify.error(result.data.message!='' && result.data.message!=undefined?result.data.message:'Not getting any response message.')
        }
        this.isPodsLoader = false
      }, error => {
        console.error(error)
      })
    },
    validateEODAllocation(deliveryuserid,hubid,obj){
      this.input = {
        "DeliveryUserID": parseInt(deliveryuserid, 10),
        "HubID": hubid,
      }
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'DayEndClosure/validateEODAllocation/deliveryuserid',
        data: this.input
      })
        .then(result => {
          if (result.data.code === 202) {
            this.ddlMisrouteReason = ''
            this.$alertify.error(result.data.message);
          }else{
            this.ddlMisrouteReason = obj.value;
          }
        })
    }
  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
  }
}

Validator.extend('validateShipmentPattern', {
  getMessage: field => 'Please Enter valid shpment no.!',
  validate: value => {
    let checkSpecialChars = /[!@#$%^&*`'[+~/(),.?":{}|<>]/;
    if( checkSpecialChars.test(value)==false){
      return true;
    } else {
      return false;
    }
  }
})



// WEBPACK FOOTER //
// ./src/views/components/AllocateHandoverShipment/AllocateHandoverShipment.component.js